import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoNumberedSteps } from "@/components/seo/SeoNumberedSteps";

const StandUpZakonczenieRoku = () => (
  <SeoPageLayout title="Stand-up na" titleAccent="zakończenie roku">
    <SeoSection title="Występ komediowy na zakończenie roku">
      <p>Zakończenie roku - czy to szkolnego, akademickiego, czy firmowego - to moment podsumowań, pożegnań i świętowania wspólnych osiągnięć. Profesjonalny stand-up na zakończeniu roku to sposób na uczczenie tego momentu z humorem i pozytywną energią. Nasi komicy potrafią humorystycznie podsumować miniony rok, nawiązać do wspólnych doświadczeń i zostawić publiczność z uśmiechem na twarzy.</p>
    </SeoSection>

    <SeoSection title="Rodzaje wydarzeń na zakończenie roku">
      <SeoStyledList items={[
        "Zakończenie roku szkolnego - występy dla nauczycieli i uczniów",
        "Zakończenie roku akademickiego - gale studenckie i uczelniane",
        "Firmowe podsumowanie roku - kolacje, bankiety, spotkania all-hands",
        "Zakończenie sezonu w klubach sportowych i organizacjach",
        "Pożegnania pracowników odchodzących na emeryturę",
        "Ceremonie wręczenia dyplomów i nagród"
      ]} />
    </SeoSection>

    <SeoSection title="Humorystyczne podsumowanie roku">
      <SeoNumberedSteps steps={[
        { title: "Zbieranie informacji", description: "Komik zbiera informacje o najważniejszych wydarzeniach minionego roku w organizacji." },
        { title: "Personalizacja materiału", description: "Tworzy spersonalizowany materiał - jak humorystyczny rocznik, w którym każdy się odnajdzie." },
        { title: "Niezapomniany finał", description: "Wspólny śmiech staje się najlepszym podsumowaniem wspólnie spędzonego czasu." },
      ]} />
    </SeoSection>

    <SeoSection title="Zamów komika na zakończenie roku">
      <p>Niech zakończenie roku będzie wydarzeniem, które wszyscy zapamiętają! Skontaktuj się z nami, opowiedz o swojej organizacji i minionym roku, a my zaproponujemy format występu, który idealnie zamknie ten rozdział.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default StandUpZakonczenieRoku;
